import React from 'react';
import { Box, Typography, GRAY } from '@applyboard/ui-components';
import { CollapsibleCard } from "../Card";
import { Grade } from "./Grade";
export var DuolingoMinimumMarks = function DuolingoMinimumMarks(_ref) {
  var minScore = _ref.minScore,
    comprehensionScore = _ref.comprehensionScore,
    productionScore = _ref.productionScore,
    conversationScore = _ref.conversationScore,
    literacyScore = _ref.literacyScore;
  if (!minScore) return null;
  var showComprehensionScore = !!comprehensionScore;
  var showProductionScore = !!productionScore;
  var showConversationScore = !!conversationScore;
  var showLiteracyScore = !!literacyScore;
  var hasAnySubScore = showComprehensionScore || showProductionScore || showConversationScore || showLiteracyScore;
  var title = 'DUOLINGO';
  return /*#__PURE__*/React.createElement(CollapsibleCard, {
    header: /*#__PURE__*/React.createElement(Typography, {
      variant: "section",
      style: {
        color: GRAY[5]
      }
    }, title),
    excerpt: /*#__PURE__*/React.createElement(Typography, {
      variant: "h2",
      style: {
        color: GRAY[5]
      }
    }, minScore),
    withSeparator: true,
    nameForEventTracking: "Minimum Language Test Scores - ".concat(title)
  }, hasAnySubScore && /*#__PURE__*/React.createElement(Box, {
    display: "flex",
    mt: 1,
    justifyContent: "space-between"
  }, showComprehensionScore && /*#__PURE__*/React.createElement(Grade, {
    type: "Comprehension",
    grade: comprehensionScore,
    displayAsDecimal: false
  }), showProductionScore && /*#__PURE__*/React.createElement(Grade, {
    type: "Production",
    grade: productionScore,
    displayAsDecimal: false
  }), showConversationScore && /*#__PURE__*/React.createElement(Grade, {
    type: "Conversation",
    grade: conversationScore,
    displayAsDecimal: false
  }), showLiteracyScore && /*#__PURE__*/React.createElement(Grade, {
    type: "Literacy",
    grade: literacyScore,
    displayAsDecimal: false
  })));
};